module.exports = "<div class=\"page-layout blank p-24\" fusePerfectScrollbar>\n\n    <h2>{{'SAMPLE.HELLO' | translate}}</h2>\n    !!!!\n</div>\n"